import React from "react";

import "@ant-design/compatible/assets/index.css";
import { Button, Select, Form } from "antd";

const { Option } = Select;

class FormOne extends React.Component {
  formOneFormRef = React.createRef();

  userIdOnChange = (e) => {
    this.props.userIdOnChange(e);
  };
  formOneOnFinish = (e) => {
    this.props.formOneOnFinish(e);
  };
  formOneOnFinishFailed = (e) => {
    console.log(e, "formOneOnFinishFailed");
  };

  render() {
    const {
      // onSubmit,
      // form,
      userListGetData,
      // foremOneUserNameOnChange
    } = this.props;

    // const dataSource = userGetData.map(d => d.role_name);

    const userOptions = userListGetData.map((d) => (
      <Option key={d._id}>
        {d.name} - {d.user_name} - {d.email}
      </Option>
    ));

    return (
      <Form
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 12 }}
        ref={this.formOneFormRef}
        onFinish={this.formOneOnFinish}
        onFinishFailed={this.formOneOnFinishFailed}
        // initialValues={formFourInitialValues}
        scrollToFirstError={true}
      >
        {/* <Form.Item label="User">
          {getFieldDecorator("user_name", {
            rules: [
              {
                required: true,
                message: "Please Enter User"
              }
            ]
          })(
            <Select
              showSearch
              placeholder="Enter User"
              onChange={foremOneUserNameOnChange}
              optionFilterProp="children"
              notFoundContent={null}
            >
              {userOptions}
            </Select>
          )}
        </Form.Item> */}

        <Form.Item
          name="user_id"
          label="User"
          rules={[
            {
              required: true,
              message: "Please Enter User",
            },
          ]}
        >
          <Select
            showSearch
            allowClear={true}
            optionFilterProp="children"
            notFoundContent={null}
            placeholder="Enter User"
            onChange={this.userIdOnChange}
          >
            {userOptions}
          </Select>
        </Form.Item>

        {/* <Form.Item wrapperCol={{ span: 12, offset: 5 }}>
          <Button type="primary" htmlType="submit">
            Select
          </Button>
        </Form.Item> */}
      </Form>
    );
  }
}

// const WrappedApp = Form.create({ name: "form_one" })(FormOne);

export default FormOne;
